module.exports = __webpack_public_path__ + "80b4010b2873cc6d11664cc0d303fb08.png";